module.exports = new __parcel__URL__("blockwallet.c6a56de0.svg").toString();